var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      placeholder: "请输入合作公司名称",
      "trigger-on-focus": false,
      debounce: 500
    },
    on: { select: _vm.handleSelect },
    model: {
      value: _vm.providerName,
      callback: function($$v) {
        _vm.providerName = $$v
      },
      expression: "providerName"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df1c9fae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df1c9fae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/providerAutoComplete.vue
// module id = 2009
// module chunks = 0